module.exports = __webpack_public_path__ + "static/media/za.bb194490.svg";